import { createSelector } from '@ngrx/store';

import { NavigationStateKey, selectGlobalAppState } from '../index';

import { initialNavigationState } from './navigation.model';

export const selectNavigationState = createSelector(selectGlobalAppState, globalState =>
  globalState ? globalState?.[NavigationStateKey] : initialNavigationState
);

export namespace NavigationSelectors {
  export const selectIsHamburgerMenuOpen = createSelector(selectNavigationState, state => state.hamburgerMenuOpen);
}
